module.exports = __webpack_public_path__ + "img/logo3.0ef43221.png";